import { createIcon } from '@chakra-ui/icons';

export const DashboardClock = createIcon({
  displayName: 'DashboardClock',
  viewBox: '0 0 12 12',
  path: [
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_915_4222)">
        <path
          d="M6 12C4.81331 12 3.65328 11.6481 2.66658 10.9888C1.67989 10.3295 0.910851 9.39246 0.456726 8.2961C0.00259972 7.19975 -0.11622 5.99335 0.115291 4.82946C0.346802 3.66558 0.918247 2.59648 1.75736 1.75736C2.59648 0.918247 3.66558 0.346802 4.82946 0.115291C5.99335 -0.11622 7.19975 0.00259972 8.2961 0.456726C9.39246 0.910851 10.3295 1.67989 10.9888 2.66658C11.6481 3.65328 12 4.81331 12 6C11.9984 7.59081 11.3658 9.11602 10.2409 10.2409C9.11602 11.3658 7.59081 11.9984 6 12ZM6 2C5.20888 2 4.43552 2.2346 3.77772 2.67412C3.11993 3.11365 2.60724 3.73836 2.30448 4.46927C2.00173 5.20017 1.92252 6.00444 2.07686 6.78036C2.2312 7.55629 2.61217 8.26902 3.17158 8.82843C3.73099 9.38784 4.44372 9.7688 5.21964 9.92314C5.99557 10.0775 6.79983 9.99827 7.53074 9.69552C8.26164 9.39277 8.88636 8.88008 9.32588 8.22228C9.76541 7.56449 10 6.79113 10 6C10 4.93914 9.57858 3.92172 8.82843 3.17158C8.07828 2.42143 7.06087 2 6 2Z"
          fill="currentColor"
        />
        <path
          d="M8.5 6.5H6C5.86739 6.5 5.74021 6.44732 5.64645 6.35355C5.55268 6.25979 5.5 6.13261 5.5 6V3.5C5.5 3.36739 5.55268 3.24021 5.64645 3.14645C5.74021 3.05268 5.86739 3 6 3C6.13261 3 6.25979 3.05268 6.35355 3.14645C6.44732 3.24021 6.5 3.36739 6.5 3.5V5.5H8.5C8.63261 5.5 8.75979 5.55268 8.85355 5.64645C8.94732 5.74021 9 5.86739 9 6C9 6.13261 8.94732 6.25979 8.85355 6.35355C8.75979 6.44732 8.63261 6.5 8.5 6.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_915_4222">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
